import { useStyleConfigV2 } from '@tectonic/elemason-components';
import { ElemasonWidgetActionType } from '@tectonic/types';
import { Button } from '../../../components';
import {
  useElemasonAnalyticsContext,
  useElemasonPageContext,
} from '../../../contexts';
import { useHaloScript } from '../../../hooks/useHaloScript';

import type { ElemasonProductLinkWidget } from '@tectonic/types';
import type { FC } from 'react';

interface ElemasonProductLinkWidgetProps {
  widget: ElemasonProductLinkWidget;
}

const ProductLinkWidget: FC<ElemasonProductLinkWidgetProps> = ({
  widget: { config, data },
}) => {
  const { dispatch } = useElemasonPageContext();
  const analyticsContext = useElemasonAnalyticsContext();
  const product = useHaloScript(data?.product);
  const [style, className] = useStyleConfigV2(config?.container);

  const onClick = () => {
    if (!product) return;

    dispatch(
      {
        type: ElemasonWidgetActionType.NAVIGATE_TO,
        payload: {
          type: data!.type,
          route: {
            slug: product.slug,
          },
        },
      },
      analyticsContext
    );
  };

  return (
    <div style={style} className={className}>
      <Button onClick={onClick} data={data?.button} config={config?.button} />
    </div>
  );
};

export { ProductLinkWidget };
